import Modal from '@/components/ui/Modal';
import type { CaixaOpcao } from '../types';

interface Props {
  aberto: boolean;
  caixas: CaixaOpcao[];
  escolhido: number | null;
  /** Quando ainda não há caixa escolhido, a folha não fecha sem uma escolha. */
  obrigatoria: boolean;
  aoEscolher: (c: CaixaOpcao) => void;
  aoFechar: () => void;
}

// Linha de apoio embaixo do nome: "Point · 3375 · imprime fichas" ou "fichas de papel".
function linhaApoio(c: CaixaOpcao): string {
  if (!c.terminal_apelido) return 'fichas de papel';
  return c.imprime_fichas ? `${c.terminal_apelido} · imprime fichas` : c.terminal_apelido;
}

// Folha "Qual caixa você está operando?" — botões grandes, uma coluna.
export default function FolhaEscolherCaixa({
  aberto,
  caixas,
  escolhido,
  obrigatoria,
  aoEscolher,
  aoFechar,
}: Props) {
  return (
    <Modal
      aberto={aberto}
      titulo="Qual caixa você está operando?"
      aoFechar={obrigatoria ? () => undefined : aoFechar}
    >
      <div className="space-y-2.5">
        {caixas.map((c) => {
          const ativo = c.caixa === escolhido;
          return (
            <button
              key={c.caixa}
              type="button"
              onClick={() => aoEscolher(c)}
              className={`flex w-full cursor-pointer items-center justify-between gap-3 rounded-2xl border-2 px-4 py-3.5 text-left transition-colors ${
                ativo
                  ? 'border-primary-500 bg-primary-50'
                  : 'border-secondary-200 bg-white hover:border-primary-300'
              }`}
            >
              <span className="min-w-0">
                <span className="block truncate text-base font-semibold text-foreground-950">
                  {c.nome}
                </span>
                <span className="mt-0.5 block truncate text-sm text-secondary-500">
                  {linhaApoio(c)}
                </span>
              </span>
              {ativo ? (
                <span className="flex h-6 w-6 shrink-0 items-center justify-center text-primary-600">
                  <i className="ri-checkbox-circle-fill text-xl" />
                </span>
              ) : (
                <span className="flex h-6 w-6 shrink-0 items-center justify-center text-foreground-400">
                  <i className="ri-arrow-right-s-line text-xl" />
                </span>
              )}
            </button>
          );
        })}
      </div>
    </Modal>
  );
}